import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BasePricingDetails } from './BasePricingDetails';

export class DefaultPricingDetails extends BasePricingDetails {
  readonly amountToBePaid: number;
  readonly amountToBePaidInLeastSubunit: number;

  constructor(productDetails: GetProductDetailsResponseType) {
    super(productDetails);

    const pricingDetails =
      productDetails.product_purchase_details_for_user.pricing_details;
    this.amountToBePaid = pricingDetails.total_amount_to_be_paid;
    this.amountToBePaidInLeastSubunit =
      pricingDetails.total_amount_to_be_paid_in_least_subunit;
  }

  get isEligibleForFreeProduct(): boolean {
    return this.amountToBePaid === 0;
  }
}
